import React from 'react';
import AssistantBotRow from '../shells/AssistantBotRow';
import UserReplyRow from '../shells/UserReplyRow';
import type { useBankAccountDetailsFlow } from './useBankAccountDetailsFlow';
import { stepQuestionKey } from './bankAccountDetailsSteps';

type Flow = ReturnType<typeof useBankAccountDetailsFlow>;

export default function BankAccountDetailsChatThread({ flow }: { flow: Flow }) {
  const { t, committed, isComplete, consentDeclined, currentStep, assistantQuestionVisible } = flow;
  const undoLabel = t('submitDocuments.chat.undo');
  const editLabel = t('submitDocuments.fillFormsChecklist.edit');

  return (
    <>
      {committed.map((c, i) => (
        <React.Fragment key={`${c.stepId}-${i}`}>
          <AssistantBotRow animateIn>{t(stepQuestionKey(c.stepId))}</AssistantBotRow>
          <UserReplyRow
            displayText={c.displayText}
            showEdit={flow.showEditForCommitIndex(i)}
            onEdit={() => flow.jumpToEditCommitIndex(i)}
            editLabel={editLabel}
            showUndo={flow.showUndoForCommitIndex(i)}
            onUndo={flow.undo}
            undoLabel={undoLabel}
          />
        </React.Fragment>
      ))}

      {!isComplete && !consentDeclined && currentStep && assistantQuestionVisible && (
        <AssistantBotRow animateIn>{t(stepQuestionKey(currentStep.stepId))}</AssistantBotRow>
      )}

      {isComplete && !flow.consentDeclined && (
        <AssistantBotRow animateIn>{t('submitDocuments.bankAccountDetails.finalConfirm')}</AssistantBotRow>
      )}
    </>
  );
}

